<template>
  <!--<app-board :header="false" class="p-3 mb-3" id="voip-testing-panel">-->
  <el-tabs @tab-click="handleClick" type="card" v-if="amReady" v-model="selectedTab">
    <el-tab-pane :lazy="true" class="" label="Testing Tool" name="testingTool">
      <div v-if="routeTabName === 'testingTool'">
        <app-board>
          <broadcast-form :allowDivisionChanging="false" :defaultDivision="defaultRouteDivision" :edit-mode="false"
                          :formHeader="false" formTitle=""></broadcast-form>
        </app-board>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="All History" name="history-all">
      <div v-if="routeTabName === 'history-all'">
        <broadcast-history v-if="isRootOrEmployee" formTitle="All History" :edit-mode="false" :formHeader="false" :statusId="0"></broadcast-history>
        <oldBroadcastHistory v-else formTitle="All History" :edit-mode="false" :formHeader="false" :statusId="0"></oldBroadcastHistory>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="Awaiting Action" name="history-awaiting-action" v-if="!isUserCustomer && !isUserReseller">
      <span class="voip-call-test-status awaiting-action" slot="label">Awaiting Action</span>
      <div v-if="routeTabName === 'history-awaiting-action'">
        <!--<broadcast-history formTitle="Awaiting Action" :edit-mode="false" :formHeader="false" :statusId="1"></broadcast-history>-->
        <oldBroadcastHistory formTitle="Awaiting Action" :edit-mode="false" :formHeader="false" :statusId="1"></oldBroadcastHistory>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="Info" name="testing-panel-info-tab">
      <span class="voip-call-test-status testing-panel-info-tab" slot="label">Info</span>
      <div v-if="routeTabName === 'testing-panel-info-tab'">
        <info-tab></info-tab>
      </div>
    </el-tab-pane>


    <el-tab-pane :lazy="true" label="Pending" name="history-pending" v-if="!isUserCustomer && !isUserMrt && !isUserReseller">
      <span class="voip-call-test-status pending" slot="label">Verified</span>
      <div v-if="routeTabName === 'history-pending'">
        <broadcast-history  formTitle="Pending" :edit-mode="false" :formHeader="false" :statusId="6"></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="Unconnected" name="history-unconnected" v-if="!isUserCustomer && !isUserReseller">
      <span class="voip-call-test-status unconnected" slot="label">Unconnected</span>
      <div v-if="routeTabName === 'history-unconnected'">
        <broadcast-history  formTitle="Unconnected" :edit-mode="false" :formHeader="false" :statusId="4"></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="FAS" name="history-fas" v-if="!isUserCustomer && !isUserReseller">
      <span class="voip-call-test-status fas" slot="label">FAS</span>
      <div v-if="routeTabName === 'history-fas'">
        <broadcast-history formTitle="FAS" :edit-mode="false" :formHeader="false" :statusId="3"></broadcast-history>
      </div>
    </el-tab-pane>

    <el-tab-pane :lazy="true" label="Working" name="history-working" v-if="!isUserCustomer && !isUserReseller">
      <span class="voip-call-test-status working" slot="label">Working</span>
      <div v-if="routeTabName === 'history-working'">
        <broadcast-history formTitle="Working" :edit-mode="false" :formHeader="false" :statusId="2"></broadcast-history>
      </div>
    </el-tab-pane>


    <el-tab-pane :lazy="true" label="Requires Test" name="history-requires-test" v-if="!isUserCustomer && !isUserMrt && !isUserReseller">
      <span class="voip-call-test-status requires-test" slot="label">Required Test</span>
      <div v-if="routeTabName === 'history-requires-test'">
        <broadcast-history formTitle="Requires Test" :edit-mode="false" :formHeader="false" :statusId="5"></broadcast-history>
      </div>
    </el-tab-pane>

    <!--
      <el-tab-pane :lazy="true" class="p-4" label="Testing Tool" name="testingTool">
        <div v-if="routeTabName === 'testingTool'">
          <broadcast-form :edit-mode="false" :formHeader="false" formTitle=""></broadcast-form>
        </div>
    </el-tab-pane>-->
  </el-tabs>

  <!--</app-board>-->
</template>
<script>

import panelMixin from '@/app/portals/cpanel/mixins/util'

export default {
  mixins: [panelMixin],
  components: {
    broadcastForm: () => import('./../broadcast-form/View.vue'),
    broadcastHistory: () => import('./../broadcast-history/page/View.vue'),
    oldBroadcastHistory: () => import('./../old-broadcast-history/page/View.vue'),
    infoTab: () => import('./../info-tab/View.vue'),
    /* uploadDocumentRate: () => import('./../upload-document-rate/View.vue'),
     manualRate: () => import('./../manual-rate/View.vue'),
     viewRates: () => import('./../view-rates/View.vue')*/
  },
  beforeMount() {
    if (this.defaultRouteDivision) {
      this.panelMixin_getUserVoipDivision('divisionsList', () => {
        let r = this.divisionsList
        for (let d in r) {
          if (r[d].label == this.defaultRouteDivision) {
            this.defaultRouteDivision = r[d].value
          }
        }
        this.amReady = true
      })
    } else {
      this.amReady = true
    }
  },
  methods: {
    /*...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),*/
    handleClick(tab, event) {
      let tabName = tab.$props.name
      let type = tabName.split('-');

      if (type[0] === 'history') {
        this.$router.push({
          name: 'module->voip-testing-panel->division->panel-tabs->tab->list->page', params: {
            division: this.$route.params.division,
            tabName: tabName,
            listPage: 1
          }
        })
      } else {
        this.$router.push({
          name: 'module->voip-testing-panel->division->panel-tabs->tab', params: {
            tabName: tabName,
            division: this.$route.params.division,
          }
        })
      }
    }
  },
  data() {
    return {
      isRootOrEmployee: $store.getters['user-state/isUserRoot'] || $store.getters['user-state/isUserPlatformEmployee'],
      defaultRouteDivision: this.$route.params.division,
      routeTabName: this.$route.params.tabName,
      tabPosition: 'top',
      selectedTab: this.$route.params.tabName,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      isUserMrt: $store.getters['user-state/isUserMrt'],
      amReady: false,
    };
  }
};
</script>

<style>
/*#voip-testing-panel .el-tabs__nav .el-tabs__item {
  padding: 0 !important;
  margin: 0 10px !important;
}*/

/*#voip-testing-panel .el-tabs__nav .el-tabs__active-bar {
  background-color: rgba(100,100,100, .0) !important;
  border: 2px solid #444;
  height: 39px;
}*/
</style>
